import type { ReactNode } from 'react'
import { SiteHeader } from '@/components/SiteHeader'
import { SiteFooter } from '@/components/SiteFooter'
import { cn } from '@/lib/utils'
import '@/components/site-page.css'

type SitePageProps = {
  /** The id of the page's one `main`, which the skip link goes to, such as `about-main`. */
  mainId: string
  /** The skip link's words. */
  skipLabel?: string
  /** Classes for the page's frame, beside `.play-site`. */
  className?: string
  /** Classes for `main`, such as `site-page__main` for the site's column and gutter. */
  mainClassName?: string
  children: ReactNode
}

/**
 * A public site or docs page (`.play-site`), as the home page and Host a watch-along are: a skip link, SiteHeader on the
 * site gutter with the roomier row, the page's one `main`, and SiteFooter. One banner, one main and one contentinfo,
 * with the header and footer outside `main`. App.tsx lists every such route as a Play surface, so it adds no shell of
 * its own around it.
 */
export function SitePage({ mainId, skipLabel = 'Skip to content', className, mainClassName, children }: SitePageProps) {
  return (
    <div className={cn('play-theme site-page play-site', className)}>
      <a className="site-page__skip" href={`#${mainId}`}>{skipLabel}</a>
      <SiteHeader />
      <main id={mainId} className={mainClassName}>{children}</main>
      <SiteFooter />
    </div>
  )
}
